import { render, staticRenderFns } from "./artSpaceCom.vue?vue&type=template&id=f825d8aa&scoped=true"
import script from "./artSpaceCom.vue?vue&type=script&lang=js"
export * from "./artSpaceCom.vue?vue&type=script&lang=js"
import style0 from "./artSpaceCom.vue?vue&type=style&index=0&id=f825d8aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f825d8aa",
  null
  
)

export default component.exports